export function MapPreferencesToTiles(preferences) {
    return preferences.map((pref, index) => {
        // Convert keys to uppercase
        const uppercaseKeys = {};
        for (const [key, value] of Object.entries(pref)) {
            if (typeof key === 'string') {
                uppercaseKeys[key.toUpperCase()] = value;
            }
        }
        pref = uppercaseKeys;

        let tilData = {};
        try {
            tilData = JSON.parse(pref.TIL_DATA);
        } catch (error) {
            console.error('Erreur lors de l\'analyse de TIL_DATA :', error);
        }

        const result = {
            id: pref.TIL_ID,
            position_x_desktop: pref.PRF_POSITION_X_DESKTOP,
            position_y_desktop: pref.PRF_POSITION_Y_DESKTOP,
            width_desktop: pref.PRF_WIDTH_DESKTOP,
            height_desktop: pref.PRF_HEIGHT_DESKTOP,
            position_x_mobile: pref.PRF_POSITION_X_MOBILE,
            position_y_mobile: pref.PRF_POSITION_Y_MOBILE,
            width_mobile: pref.PRF_WIDTH_MOBILE,
            height_mobile: pref.PRF_HEIGHT_MOBILE,
            max_height: pref.PRF_MAX_HEIGHT,
            min_height: pref.PRF_MIN_HEIGHT,
            max_width: pref.PRF_MAX_WIDTH,
            min_width: pref.PRF_MIN_WIDTH,
            colorId: pref.TCO_ID,
            color: pref.TCO_HEXA,
            type: pref.TYP_NAME,
            data: tilData,
            notification: pref.NOTIFICATIONS || null,
            evenement: pref.EVENEMENTS || null,
            isOptional: pref.TIL_IS_OPTIONAL,
            createdAt: pref.TIL_CREATED_AT,
        };
        
        return result;
    });
}